
import { ReactNode, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const location = useLocation();
  
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col px-4 sm:px-8 md:px-12 lg:px-24 max-w-7xl mx-auto">
      <Header />
      <main className="flex-grow w-full max-w-5xl mx-auto mb-16 animate-page-enter">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
